/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { RichTextSimple } from "@simplicitycms/simplicity-richtext";
import { ReactComponent as RightArrowAltIcon } from "cms/assets/icons/right-arrow-alt.svg";
import { SimplicitySimpleImageLoader } from "cms/image/image-simple-loader";

const TestimonialHighlight = (props) => {
    const component = props?.component;
    const title = component?.title;
    const description = component?.description;
    const image = component?.image;
    const company_logo = component?.company_logo;
    const testimonial_quote = component?.testimonial_quote;
    const person_image = component?.person_image;
    const person_name = component?.person_name;
    const person_title = component?.person_title;
    const person_company = component?.person_company;
    const link = component?.link;

    return (
        <Fragment>
            <div className="testimonial-highlight-display-content">
                <div className="testimonial-highlight-display-content-title">
                    {title}
                </div>
                <div className="testimonial-highlight-display-content-description">
                    {description}
                </div>
                <div className="testimonial-highlight-display-content-container">
                    <div className="testimonial-highlight-display-content-image">
                        <SimplicitySimpleImageLoader
                            className="testimonial-highlight-display-content-image-img"
                            guid={image}
                            alt={title}
                        />
                    </div>
                    <div className="testimonial-container">
                        <div className="testimonial-icon">
                            <SimplicitySimpleImageLoader
                                guid={company_logo}
                                alt={title}
                            />
                        </div>
                        <div className="testimonial_quote">
                            <RichTextSimple
                                richtext={testimonial_quote}
                            />
                        </div>
                        <div className="testimonial-person-info">
                            <div className="testimonial-person-icon">
                                <SimplicitySimpleImageLoader
                                    style=""
                                    guid={person_image}
                                    alt={person_name}
                                />
                            </div>
                            <div className="testimonial-person-details">
                                <div className="testimonial-person-name">
                                    {person_name}
                                </div>
                                <div className="testimonial-person-title">
                                    {person_title}
                                </div>
                                <div className="testimonial-person-company">
                                    {person_company}
                                </div>
                            </div>
                        </div>
                        {link &&
                            <div className="testimonial-link-container">
                                <a className="testimonial-link"
                                    href={link?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >{link?.text}</a>
                                <div className="testimonial-link-icon" onClick={() => window.open(link?.url, "_blank")}>
                                    <RightArrowAltIcon />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

TestimonialHighlight.displayName = "TestimonialHighlight";
export { TestimonialHighlight };
